import IconLoader from "components/IconLoader/IconLoader";
// import { CircularProgress } from "components/Progress/CircleProgressbar";
import { SurveyTagLabel } from "constants/enums/StudentSurveyEnum";
import React from "react";
import { useState } from "react";
import { Collapse } from "react-bootstrap";

function SurveyTag({
  selectedCategory,
  setSelectedCategory,
  answer,
  category,
  missingRequiredFields = []
}) {
  const [open, setOpen] = useState(true);
  const isSelectedTag = (tag) => {
    if (!selectedCategory) return false;
    return selectedCategory?.taggedId === tag?.taggedId && selectedCategory?.branch === tag?.branch;
  };

  // Check if this category has missing required questions
  const hasMissingRequired = missingRequiredFields.some(
    (item) => item.category.tag === category.tag
  );

  return (
    <div
      className={`rounded border overflow-hidden mb-2 ${
        hasMissingRequired ? "border-danger shadow-sm" : ""
      }`}
      style={{ color: "#646E78", background: hasMissingRequired ? "#fff8f8" : "#F2F2FC" }}
    >
      <div
        onClick={() => setOpen(!open)}
        className={`lms-font-bold cursor-pointer py-2 d-flex align-items-center justify-content-between ${
          open && "border-bottom border-2"
        }`}
      >
        <div>
          <IconLoader icon={!open ? "mdiChevronDown" : "mdiChevronUp"} size={1} />
          {SurveyTagLabel[category?.tag] || category?.tag}
        </div>
        {hasMissingRequired && (
          <div
            className="mr-3 text-danger position-relative"
            title="Bu kategoride doldurulmamış zorunlu sorular var!"
          >
            <span className="badge badge-danger badge-pill mr-2">!</span>
            <IconLoader icon="mdiAlert" size={1} />
          </div>
        )}
      </div>
      <Collapse in={open}>
        <div className="bg-white">
          {category?.tagList.map((tag) => (
            <div
              className={`d-flex align-items-center justify-content-between px-4 py-2 border-bottom cursor-pointer ${
                isSelectedTag(tag) && "lms-text-primary text-white font-weight-bold"
              }`}
              key={tag?.taggedId + tag?.branch}
              onClick={() => setSelectedCategory(tag)}
            >
              <p className="p-0 m-0">{tag.taggedName}</p>
              <p className="p-0 m-0">
                {(
                  (answer.filter(
                    (_answer) =>
                      _answer?.taggedId === tag?.taggedId && _answer?.branchInfo?.id === tag?.branch
                  ).length /
                    category?.questionCount) *
                  100
                )?.toFixed(2)}
                %
              </p>
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
}

export default SurveyTag;
